export default async ({ asyncOps, store }) => {
  return {
    dashboard: {
      action: {
        type: "routerNavigation",
        data: {
          to: { name: "admin" },
        },
      },
      icon: "dashboard",
      label: "admin.sideNav.dashboard",
    },
    ecommerceTitle: {
      action: {
        type: "title",
      },
      permissions: {
        method: "canAnySoft",
        rules: [
          {
            asset: "vendor",
            actions: ["update"],
            level: "all",
          },
          {
            asset: "order",
            actions: ["list", "update"],
            level: "all",
          },
          {
            asset: "brand",
            actions: ["create", "update"],
            level: "all",
          },
          {
            asset: "product",
            actions: ["create", "update"],
            level: "all",
          },
        ],
      },
      label: "admin.sideNav.ecommerce",
    },
    vendor: {
      action: {
        type: "routerNavigation",
        data: {
          to: { name: "admin-vendor" },
        },
      },
      permissions: {
        asset: "vendor",
        actions: ["update"],
        level: "all",
      },
      icon: "cart",
      label: "admin.sideNav.vendor",
    },
    brand: {
      action: {
        type: "routerNavigation",
        data: {
          to: {
            name: "entity-list",
            params: { entityType: "brand" },
          },
        },
      },
      permissions: {
        asset: "brand",
        actions: ["update"],
        level: "all",
      },
      icon: "cart-basket",
      label: "admin.sideNav.brand",
    },
    product: {
      action: {
        type: "routerNavigation",
        data: {
          to: { name: "admin-product" },
        },
      },
      permissions: {
        asset: "product",
        actions: ["update"],
        level: "all",
      },
      icon: "bar-code",
      label: "admin.sideNav.product",
    },
    order: {
      action: {
        type: "routerNavigation",
        data: {
          to: { name: "admin-order" },
        },
      },
      product: {
        asset: "order",
        actions: ["list"],
        level: "all",
      },
      icon: "credit-cards",
      label: "admin.sideNav.order",
    },
    generalTitle: {
      action: {
        type: "title",
      },
      label: "admin.sideNav.generalTitle",
    },
    entities: {
      action: false,
      icon: "layer-stack",
      label: "admin.sideNav.entities",
      children: {
        entityDashboard: {
          action: {
            type: "routerNavigation",
            data: {
              to: { name: "entity-dashboard" },
            },
          },
          icon: "layer-stack",
          label: "admin.sideNav.entityDashboard",
        },
        category: {
          icon: "handle-horizontal",
          label: "admin.sideNav.category",
          action: {
            type: "routerNavigation",
            data: {
              to: {
                name: "entity-list",
                params: { entityType: "category" },
              },
            },
          },
        },
        tag: {
          icon: "hashtag",
          label: "admin.sideNav.tag",
          action: {
            type: "routerNavigation",
            data: {
              to: {
                name: "entity-list",
                params: { entityType: "tag" },
              },
            },
          },
        },
        article: {
          icon: "pencil-write",
          label: "admin.sideNav.article",
          action: {
            type: "routerNavigation",
            data: {
              to: {
                name: "entity-list",
                params: { entityType: "article" },
              },
            },
          },
        },
      },

    },
    media: {
      label: "admin.sideNav.media",
      icon: "image",
      action: {
        type: "routerNavigation",
        data: {
          to: {
            name: "admin-media",
          },
        },
      },
      permissions: {
        asset: "media",
        actions: ["update"],
        level: "all",
      },
    },
    userTitle: {
      action: {
        type: "title",
      },
      label: "admin.sideNav.userTitle",
      permissions: {
        asset: "user",
        actions: ["update"],
        level: "all",
      },
    },
    user: {
      action: {
        type: "routerNavigation",
        data: {
          to: { name: "admin-user" },
        },
      },
      permissions: {
        asset: "user",
        actions: ["update"],
        level: "all",
      },
      icon: "user",
      label: "admin.sideNav.user",
    },
    acl: {
      action: {
        type: "routerNavigation",
        data: {
          to: { name: "admin-acl" },
        },
      },
      permissions: {
        asset: "feACL",
        actions: ["update"],
        level: "all",
      },
      icon: "lock",
      label: "admin.sideNav.acl",
    },
    settingsTitle: {
      action: {
        type: "title",
      },
      permissions: {
        method: "canAnySoft",
        rules: [
          {
            asset: "configEntry",
            actions: ["update"],
            level: "all",
          },
          {
            asset: "languageEntry",
            actions: ["update"],
            level: "all",
          },
        ],

      },
      label: "admin.sideNav.settingsTitle",
    },
    language: {
      action: {
        type: "routerNavigation",
        data: {
          to: { name: "admin-language" },
        },
      },
      permissions: {
        asset: "languageEntry",
        actions: ["update"],
        level: "all",
      },
      icon: "chat-message-alt",
      label: "admin.sideNav.language",
    },
    settings: {
      action: {
        type: "routerNavigation",
        data: {
          to: { name: "admin-config" },
        },
      },
      permissions: {
        asset: "configEntry",
        actions: ["update"],
        level: "all",
      },
      icon: "settings",
      label: "admin.sideNav.config",
    },
  };
};
